// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher__Gcml1","button":"button__I4Ifi","active":"active__C+w5R","light":"light__mmuHC"};